import { call, fork, put, take, select } from 'redux-saga/effects';
import api from 'services';
import * as actionTypes from 'constants/ActionTypes';
import { refNumber } from '../refNumber';

function* postRequestCargo(cargoRequest) {
    const response = yield call(api.postRequestCargo, cargoRequest);

    if (response.status === 200) {
        yield put({
            type: actionTypes.POST_CARGO_REQUEST.SUCCESS,
            data: response.data,
            cargoRequest,
        });

        yield put({
            type: actionTypes.ADD_NOTIFICATION,
            notification: {
                title: `Success cargo request - ${cargoRequest.keyCargoOrder + 1}`,
                message: `${response.data.message || 'Found duplicate cargo.'}`,
                level: 'success',
                _id: new Date().getMilliseconds(),
                autoDismiss: 10,
            },
        });

        yield call(refNumber, response.data);
        return response;
    }

    yield put({
        type: actionTypes.ADD_NOTIFICATION,
        notification: {
            title: `Error cargo request - ${cargoRequest.keyCargoOrder + 1}`,
            message: response.errors[0].message || response.errors[0].messages[0],
            level: 'error',
            _id: new Date().getMilliseconds(),
            autoDismiss: 10,
        },
    });

    yield put({
        type: actionTypes.POST_CARGO_REQUEST.FAILURE,
        errors: response.errors,
        cargoRequest,
    });

    return response;
}

export function* watchPostRequestCargo() {
    while (true) {
        const { cargoRequest } = yield take(actionTypes.POST_CARGO_REQUEST.REQUEST);
        yield fork(postRequestCargo, cargoRequest);
    }
}

/**
 *
 * */
function* getRequestsCargo(filter) {
    const response = yield call(api.getCargoMonitor, filter);

    if (response.status === 200) {
        yield put({
            type: actionTypes.GET_CARGO_REQUESTS.SUCCESS,
            data: response,
        });

        return response;
    }

    yield put({
        type: actionTypes.GET_CARGO_REQUESTS.FAILURE,
        errors: response.errors,
    });

    return response;
}

export function* watchGetRequestsCargo() {
    while (true) {
        const { filter } = yield take(actionTypes.GET_CARGO_REQUESTS.REQUEST);
        yield fork(getRequestsCargo, filter);
    }
}

function* updateRequestsCargo(cargoRequestId, userId) {
    const response = yield call(api.changeUserCargoRequest, cargoRequestId, userId);

    if (response.status === 200) {
        yield put({
            type: actionTypes.UPDATE_CARGO_REQUEST.SUCCESS,
            cargoRequestId,
            userId,
        });

        yield put({
            type: actionTypes.ADD_NOTIFICATION,
            notification: {
                title: 'Success',
                message: response.data.message,
                level: 'success',
                _id: cargoRequestId,
                autoDismiss: 2,
            },
        });
        return;
    }

    yield put({
        type: actionTypes.UPDATE_CARGO_REQUEST.FAILURE,
        errors: response.errors,
        cargoRequestId,
        userId,
    });

    yield put({
        type: actionTypes.ADD_NOTIFICATION,
        notification: {
            title: 'Error',
            message: response.errors[0].messages[0],
            level: 'error',
            _id: cargoRequestId,
            autoDismiss: 2,
        },
    });
}

export function* watchUpdateRequestsCargo() {
    while (true) {
        const { cargoRequestId, userId } = yield take(actionTypes.UPDATE_CARGO_REQUEST.REQUEST);
        yield fork(updateRequestsCargo, cargoRequestId, userId);
    }
}

function* deleteRequestsCargo(cargoRequestId) {
    const response = yield call(api.deleteCargoRequest, cargoRequestId);

    if (response.status === 200) {
        const store = yield select();

        yield put({
            type: actionTypes.DELETE_CARGO_REQUEST.SUCCESS,
            cargoRequestId,
            email: store.user.user.email,
        });

        yield put({
            type: actionTypes.ADD_NOTIFICATION,
            notification: {
                title: 'Success',
                message: response.data.message,
                level: 'success',
                _id: cargoRequestId,
                autoDismiss: 2,
            },
        });
        return;
    }

    yield put({
        type: actionTypes.DELETE_CARGO_REQUEST.FAILURE,
        cargoRequestId,
        error: response.errors,
    });

    yield put({
        type: actionTypes.ADD_NOTIFICATION,
        notification: {
            title: 'Error',
            message: response.errors[0].messages[0],
            level: 'error',
            _id: cargoRequestId,
            autoDismiss: 2,
        },
    });

}

export function* watchDeleteRequestsCargo() {
    while (true) {
        const { cargoRequestId } = yield take(actionTypes.DELETE_CARGO_REQUEST.REQUEST);
        yield fork(deleteRequestsCargo, cargoRequestId);
    }
}

export default [
    watchPostRequestCargo,
    watchGetRequestsCargo,
    watchUpdateRequestsCargo,
    watchDeleteRequestsCargo,
];



// WEBPACK FOOTER //
// ./app/sagas/cargoes/requests.js